import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import {
  Box,
  Button,
  Grid,
  styled,
  Typography,
  useTheme
} from "@mui/material"

import { OpenInNewRounded } from "@mui/icons-material"

import i18n from "./i18n"

import packageJson from "../package.json"

import "./App.css"

const StyledContainer = styled("div", {
})(({ theme }) => {
  return {
    backgroundImage: "url(/static/images/background.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "row",
    height: "100%",
    width: "100%",
    overflowY: "auto",
    "& .MuiGrid-root": {
      width: "50%",
      height: "100%",
      zIndex: 1,
      minHeight: 260
    },
    "&::before": {
      content: "''",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.15)",
      position: "absolute",
      zIndex: 0
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      "& .MuiGrid-root": {
        width: "100%",
        height: "50%"
      },
      "&::before": {
        backgroundColor: "rgba(0,0,0,0.30)"
      }
    }
  }
})

const Section = ({ logo, title, text, link, linkText }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 4, boxSizing: "border-box"
      }}
    >
      <Box
        sx={{
          maxWidth: "75%",
          textAlign: "center",
          p: 4,
          color: theme.palette.primary.contrastText
        }}
      >
        <Box
          component="img"
          src={logo}
          alt={title}
          sx={{ height: 80, mb: 3 }}
        />
        <Typography variant="body1" fontWeight={500} sx={{ mb: 3 }}>
          {text}
        </Typography>
        <Button
          color="inherit"
          variant="outlined"
          size="large"
          endIcon={<OpenInNewRounded />}
          href={link}
          target="_blank"
        >
          {linkText}
        </Button>
      </Box>
    </Box>
  )
}

function App() {
  const theme = useTheme()
  const { t } = useTranslation()

  const [selectedLanguage, setSelectedLanguage] = useState(window.location.hostname.endsWith(".nl") || window.location.hostname === "localhost"
    ? "nl"
    : "en"
  )

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage)
  }, [selectedLanguage])

  return (
    <div className="App" id="app">
      <StyledContainer>
        <Grid>
          <Section
            logo="/static/images/hkv-wit-80.png"
            title={t("hkv_name")}
            text={t("hkv_subtitle")}
            link={t("hkv_link")}
            linkText={`${t("Go_to")} ${t("hkv_link").replace("https://", "")}`}
          />
        </Grid>
        <Grid>
          <Section
            logo="/static/images/svasek-wit-80.png"
            title={t("svasek_name")}
            text={t("svasek_subtitle")}
            link={t("svasek_link")}
            linkText={`${t("Go_to")} ${t("svasek_link").replace("https://", "")}`}
          />
        </Grid>
      </StyledContainer>
      <Typography
        lineHeight={1} fontSize={12}
        color="primary.contrastText"
        sx={{
          position: "absolute", right: theme.spacing(1), bottom: theme.spacing(1),
          zIndex: 1
        }}
      >
        {t("Version")}: {packageJson.version}
      </Typography>
    </div>
  )
}

export default App
